export default [
  {
    text: "Administrador",
    icon:"fa-solid fa-house-user",
    items: [
      {
        text: "Grupos",
        icon:"fa-solid fa-people-group",
        path:"/group"
      },
      {
        text: "Sub Grupos",
        icon:"fa-solid fa-user-group",
        path:"/sub-group"
      },
      {
        text: "Usuarios",
        icon:"fa-solid fa-users",
        path:"/users"

      },
      {
        text: "Importar usuarios",
        icon:"fa-solid fa-file-import",
        modal:true,
        id_modal:1,
      },
      {
        text: "Keys",
        icon:"fa-solid fa-key",
        path:"/keys",
      },
      {
        text: "Tienda Virtual",
        icon:"fa-solid fa-store",
        path:"/shop", 
      },
      {
        text: "Auditoria",
        icon:"fa-solid fa-file-lines",
        path:"/auditoria",
      },
      {
        text: "Ayuda Administrador",
        icon:"fa-solid fa-circle-question",
        openLink:true,
        link:'https://www.3dissect.com/help/Ayuda_Administrador.pdf'
      },
      {
        text: "Activar Tomo",
        icon:"fa-solid fa-lock",
        modal:true,
        id_modal:3
      }
    ]
  },
  {
    text: "Tomos",
    icon:"fa-solid fa-book",
    path:"/tomo"
  },
  {
    text: "Escenas",
    icon:"fa-solid fa-film",
    path:"/views"
  },
  {
    text: "Quices",
    icon:"fa-solid fa-pen-to-square",
    path:"/quiz"
  },
  {
    text: "Videos",
    icon:"fa-solid fa-video",
    path:"/video"
  },
  {
    text: "Ayuda",
    icon:"fa-solid fa-circle-question",
    openLink:true,
    link:'https://www.3dissect.com/help/Inicio.html'
  },
  {
    text: "Video Guías",
    icon:"fa-solid fa-file-video",
    path:"/video-guides"
  },
  {
    text: "Soporte",
    icon:"fa-solid fa-envelope-open-text",
    modal:true,
    id_modal:2
  }
  ];
